import {useSelector} from "react-redux";
import { RootState} from "../../Store";
import Style from "./Style.module.scss";
import { usePlayOrStop} from "../index";
import { useProgress} from "../progress";
import {useEffect, useState} from "react";
import { AppState} from "../state";
import { More} from "./More";
import { Volume} from "./Volume";
import { ProgressBar as UtilProgress } from "../../ProgressBar";
import { EpisodePlayerRow} from "../../Item/Podcast/EpisodePlayerRow";
import { RadioPlayerRow} from "../../Item/Radio/RadioPlayerRow";
import { slugifyPath } from "../../../utils/slugifyPath";
import { Rychlost} from "./Rychlost";

import backsvg from "../../../static/back.svg";
import nextsvg from "../../../static/next.svg";
import broadcastsvg from "../../../static/broadcast.svg";
import playbuttoncastsvg from "../../../static/playbuttonpodcast.svg";
import playbuttonsvg from "../../../static/playbutton.svg";
import loadingbuttonpodcastsvg from "../../../static/loadingbuttonpodcast.svg";
import loadingbuttonsvg from "../../../static/loadingbutton.svg";
import playingbuttonpodcastsvg from "../../../static/playingbuttonpodcast.svg";
import playingbutton from "../../../static/playingbutton.svg"

export const InnerProgress = (props: {
    startPosition: number,
    duration: number,
    playedItem: EpisodePlayedItemTime
}) => {
    const progress = useProgress();
    const [position, setPosition] = useState({ c: props.startPosition, d: props.duration });

    useEffect(() => {
        setPosition({
            c: props.startPosition,
            d: props.duration
        })
        return progress.addListener((c, v)=> {
            setPosition({ c: c, d: v })
        });
        // eslint-disable-next-line
    }, [props.startPosition, props.duration])


    return <div className={Style.Progress}>
            <div className={Style.Where}>
                {Math.floor(position.c / 60)}:{`${Math.floor(position.c) % 60}`.padStart(2, '0')}
            </div>
            <div className={Style.Max}>
                {Math.floor(position.d / 60)}:{`${Math.floor(position.d) % 60}`.padStart(2, '0')}
            </div>
            <a className={Style.Prev} href={"#position"} onClick={e=>{
                e.preventDefault();
                progress.setPosition(position.c - 15, props.playedItem)
            }}>
                <img alt="Zpět o 15s" src={backsvg} />
            </a>
            <a href={"#position"} className={Style.Next} onClick={e=>{
                e.preventDefault();
                progress.setPosition(position.c + 15, props.playedItem)
            }}>
                <img alt="Dopředu o 15s" src={nextsvg} />
            </a>
            <UtilProgress value={position.c/position.d} onChange={e=>{
                progress.setPosition(e * position.d, props.playedItem);
            }}/>
        </div>


}
export const Progress = () => {

    const playedItem = useSelector((item: RootState) => item.playedItem);

    let path = "1";
    if (playedItem)
        path = slugifyPath(playedItem, true);

    const curPosition = useSelector((state: AppState) => playedItem  ? ((state.positions.find(x => x.slug === path)?.time) ?? 0) : 0);

    if (!playedItem || !("programSlug" in playedItem))
        return null;

    const duration = playedItem.duration;

    if (duration <= 0)
        return null;

    return <InnerProgress startPosition={curPosition} duration={duration} playedItem={playedItem}/>
}


export const BottomViewPlayerInner = () => {
    const item = useSelector((state: RootState) => state.playedItem);

    const player = usePlayOrStop(item);

    if (!item || typeof window === "undefined")
        return null;

    const isPodcast = "programSlug" in item;

    let icon = isPodcast ? playbuttoncastsvg : playbuttonsvg;
    if (player.isPlaying()) {
        if (player.isLoading()) {
            icon = isPodcast ? loadingbuttonpodcastsvg : loadingbuttonsvg;
        }
        else
        {
            icon = isPodcast ? playingbuttonpodcastsvg: playingbutton;
        }
    }
    return <>
        <div id={"player-bottom"} className={`${Style.Bottom} d-flex justify-content-center`}>
            <div className={`d-flex `}>
                <div className={`${Style.Radio} align-self-center`}>
                    {isPodcast ? <EpisodePlayerRow className={Style.info} episode={item} /> : <RadioPlayerRow radio={item} /> }
                </div>
                <div style={{
                    position: "relative"
                }}>
                    <Progress  />
                </div>
                <div className={`${Style.Buttons} justify-content-end d-flex`}>
                    {isPodcast ?  <Rychlost key={"rychlost"}/> : null}
                    <div className={"align-self-center"} >
                        <Volume/>
                    </div>
                    <div className={"ms-24px  align-self-center"} >
                        <More />
                    </div>
                </div>
            </div>
            <div className={`${Style.Play} `} >
                <a href={"#play"} onClick={ev => {
                    ev.preventDefault();
                    player.play();
                }}>
                    <img src={icon} className={'hvr-pop'} alt={isPodcast ? "Podcast" : "Rádio"}/>
                </a>
                <div className={Style.PlayType}>{player.isPlaying() ? <><img alt="" src={broadcastsvg}/>&nbsp;&nbsp;</>: false}<strong className={"opacity-60"}>{isPodcast? "Podcast" : "Rádio"}</strong></div>
            </div>

        </div>
        <span className={`${Style.BottomFixedMain}`} />
        <span className={Style.BottomFixed} />
    </>;
}

export default BottomViewPlayerInner;